import React, { useState } from "react";
import Profile1page from "../components/profile/ProfileLeftSide";
import FotographiyaProfile from "../components/profile/Fotographiya_Profile";
// import FotographiyaWallet from "../components/profile/Fotographiya_wallet";
import Navbar from "../components/common/Navbar";
// import TransactionHistory from "../components/ProfileArea/";
import "../styles/pages/Fotographiyamain.css";
// import TransactionHistory from "./Dashbord_component/TransactionHistory";

const FotographiyaMain = ({ profileImage, setProfileImage }) => {
  const [activeSection, setActiveSection] = useState(0);

  return (
    <>
      <Navbar />
      <div className="maindiv" style={{ display: "flex" }}>
        <Profile1page
          activeIndex={activeSection}
          onSectionChange={(index) => setActiveSection(index)}
        />

        {activeSection === 0 && (
          <FotographiyaProfile
            profileImage={profileImage}
            setProfileImage={setProfileImage}
          />
        )}
        {/* {activeSection === 1 && <FotographiyaWallet />} */}
      </div>
    </>
  );
};

export default FotographiyaMain;
